import { lazy } from 'react'

import { roles } from 'constant/roles'
import {
  masterPayroll,
  hubStaffScheduleBulkUpload,
  mpBudget,
  mpPlanning,
  hubStaff,
  centralWarehouseStaff,
} from 'config/routes'
import generateRouterDetail from 'utils/helpers/generateRouterDetail'

const ManPowerBulkUpload = lazy(() => import('../pages/ManPowerBulkUpload'))
const MPBudget = lazy(() => import('../pages/MPBudget'))

type NamedRoutesType =
  | 'MasterPayroll'
  | 'ScheduleBulkUploadRouter'
  | 'MPPlanningRouter'
  | 'MPBudgetRouter'
  | 'HubStaffRouter'
  | 'CentralWarehouseRouter'

type PathListsType =
  | typeof masterPayroll
  | typeof hubStaffScheduleBulkUpload
  | typeof mpBudget
  | typeof mpPlanning
  | typeof hubStaff
  | typeof centralWarehouseStaff

type RouterInstanceType = RouterFeatureInterface<NamedRoutesType, PathListsType>

export const MPPlanningRouter: RouterInstanceType = {
  name: 'MPPlanningRouter',
  Component: () => <ManPowerBulkUpload type="planning" />,
  path: mpPlanning,
  routeType: 'PRIVATE',
  allowedRoles: [roles.AUTH_CAPTAIN, roles.AUTH_DRIVER_COORDINATOR, roles.AUTH_MARKETING],
  isDashboard: true,
}

export const MPBudgetRouter: RouterFeatureInterface<'MPBudgetRouter', '/dashboard/mp-budget'> = {
  name: 'MPBudgetRouter',
  Component: MPBudget,
  path: '/dashboard/mp-budget',
  routeType: 'PRIVATE',
  allowedRoles: [roles.AUTH_HO_OPX_MID_MILE, roles.AUTH_HO_OPX_HUB],
  isDashboard: true,
}

const HRISRouter = [MPPlanningRouter, MPBudgetRouter]

export const HRISRouterDetail = generateRouterDetail(HRISRouter)

export default HRISRouter
